export enum MANAGER_CARD_TYPE {
  /**
   * 页面名片
   */
  PageCard = 0,
  /**
   * 顶部悬浮卡片
   */
  HeaderCard = 1,
  /**
   * 海报名片
   */
  PosterCard = 2,
}

export enum CERTIFICATE_SHOW_TYPE {
  /**
   * 个人证书
   */
  PersonalCertificate,
  /**
   * 组合证书
   */
  GroupCertificate,
}

export const HEAD_EDIT_ICON =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAABSBJREFUaEPdml1oXEUUx8+ZuXfX3azJJiHR4EONlVobTCurhRYE33wRaZQUQRT1oQ9ixdpojCAEFL9ri4oPPggqgiRgVXzxyRdpQRK0kaS2tKYFoSQhn+5m3b1z58jc/czmbu7c/cTdt+TOOXN+d2bO+c/MRajVb3iCxzrvCEInmAnWZgQskwcxxaSJqLpgFlGKgjJtWnabTAhYBWt69a8UTB61axGC00mlv+Fh4nMDSyEevxHmLGhU4seWKWFH+jb3zfYkJyexYqiKQGLHpsx0V0/EkMlQJcGXsxEslAysLMWnP7vP8uvXH8g4sQNr19oxkAr77chPe0oHN3+P3r4B4yh17bRBDp04F9owOjoCyJmu82rapcmW7WJ9/fzpw0kdP1ogsdGrHZKsNh2HtW7D0ExMv7t73cuvBwjhwbE/uywbg16O6vnc5JT69e29KwBI5frZAYQwdvJyt+QUqGeQur6ZjenpU3uWy8GUBTk4drG72SNRCpkZmbuX3eBdQZq5JrxGqNya2QaistO/Zlenl8NmPr/JWlktzWZbQcaJDSTmehuVYit9GSo1z7btWyyuM1tADrw4H9UpdjbAzYbBHkHAW3SDISmv2Sk4y0xyzTzSQjTDMKT8WZvl2+X6c4rmmf613N95ECU7ZDTS4xWYggiYxk8AtMurbelzacvjJOlb18VqsjcZ4DOZZ/K4bbm3K7Zla/GlnJzJg9zz6vVOHe2EBnuCIb7nF8IJrwwI4+wEMhwp+NQDUdrsj3d2rSo7B0Sp2Cv9l7SmCTP4S4hwMtvpOSI4rwNVbmoxkz+FgG8BkBMLEXwnkvL5clOwtK875+9aUKrZMR4YX4wENlfadQIqBiGCU1LYH+rYubUxTONhAvgUgLgDAfgzCHxakiV0fabDXRuz471xB2Rw5EKv7n6iViDIjAeQ05cI4CgHRJy2E6nHyeSbuhCqndrPzHywfxFheILf2z+oNa2UYU1ADGM/Q5pAgEg26Mu2hCGw7XwW8gPz2/zMAsaOTYVlNBLVNawWBDnuZoydBYBup0+Cv6XEIyTFDd0YStuxtfgaxkanOiRFtCV6NSDIjD7k8nsEvC0bzLKUcohsulophDNLMJ7AvWMXu0M+ZHrFIJxHOQM1EnsyAwFxSXgUhLhQDYSyTXJK4eDIlV7OhPbBQSUgaNlh3hb8hohiWYg0EX+SRPqXHISq7DyYqew7KQA3aFsaAu9/efZW4WP76heEoWmAIb9AgAczQTg5/zlhiR+Lg0KGjzLOPlb/20kBuKZxsiXGXpvrk4JpbXn9Zi31lo0Q+wQRjmQhiIjGpLC/2rZgiwqt3/rEDEl1BUGDv8EQns0HTfi+LcQZt7fqd6SLfTgg9ZpaLGA8hkQf5dcAweck7NfLLexqQAw1teq12Blno8jwBWdxa+inakCcxV639KvSLcIoEKyQZKe99FM1IE76bWRB3KleVAPiFMRGS5R6rBFHojRFNLrQVDMijmhUPpsh42tVRwoyvokbq621oLDz9FMQt2ysGrHV9RKGiHAIAA5n07X2znPLVlcZN+LwwQumUDzpFRLya6/22w4flEEjjoO8AnNGA+C6ZdkPcYB/vNq7Hgcpo3oe0HkFlYGgBSHkDzoQZQ/onI5a5chUsbTGIXZ2/FviWiE3l1vioicD0yJXbzmYFrgMLSTMZq6ZGl1PF2Ba4oOBPE4rfMJRXJn//x/VlOgMpZpn+i+FgzIV0r2WKJUqTf3MyVU3NfnDs/8Ad8x28HcZEXMAAAAASUVORK5CYII=';
